import * as React from 'react';

import { Container } from './loader.styles';
import { CircularProgress } from '@sitegen/ui/src/components/circular-progress/circular-progress.component';

export interface ILoaderProps {
    readonly size?: number;
    readonly color?: string;
    readonly inline?: boolean;
}

export const Loader: React.FC<ILoaderProps> = (props: ILoaderProps) => (
    <Container inline={props.inline}>
        <CircularProgress size={props.size} color={props.color} />
    </Container>
);

Loader.defaultProps = {
    size: 50,
    color: '#3f51b5'
};

Loader.displayName = 'Loader';

export default Loader;
